import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import { ThemeProvider as ThemeProvider$1 } from 'styled-components';
import { C as ConfigObserver } from './ConfigObserver-56ae89b8.js';
import { d as defaultTheme } from './themes/default-df802324.js';
import { e as evolutionTheme } from './themes/evolution-53b6df54.js';
import { d as deepMerge$1 } from '../LocalModules/storm-ui-utils/dist/esm/deepMerge-8f442bea-008d6945.js';

class ThemeProvider extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "isEvolutionTheme", void 0);
    _defineProperty(this, "theme", void 0);
    this.isEvolutionTheme = false;
    this.theme = props.theme;
  }
  render() {
    const {
      theme,
      children
    } = this.props;
    return /*#__PURE__*/React__default.createElement(ConfigObserver, null, config => {
      if (typeof theme === 'function') {
        this.theme = theme;
      }
      if (this.isEvolutionTheme !== config.evolutionTheme) {
        this.isEvolutionTheme = config.evolutionTheme;
        if (config.evolutionTheme && typeof theme === 'object') {
          this.theme = deepMerge$1({}, theme, evolutionTheme);
        } else {
          this.theme = theme;
        }
      }
      return /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
        theme: this.theme
      }, children);
    });
  }
}
_defineProperty(ThemeProvider, "propTypes", {
  children: PT.node.isRequired,
  theme: PT.oneOfType([PT.objectOf(PT.any), PT.func])
});
_defineProperty(ThemeProvider, "defaultProps", {
  theme: defaultTheme
});

export { ThemeProvider as T };
//# sourceMappingURL=ThemeProvider-c5bee48f.js.map
